// extracted by mini-css-extract-plugin
module.exports = {"offerBadgeContainer":"purify_defaultOfferBadge__offerBadgeContainer--18jPH","offerBadgeText":"purify_defaultOfferBadge__offerBadgeText--10hTE"};